import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.inspection-step-page-title {
  color: ${dt('inspectionStepPageTitle.title.color')};
  font-size: ${dt('inspectionStepPageTitle.title.fontSize')};
  font-weight: ${dt('inspectionStepPageTitle.title.fontWeight')};
  line-height: ${dt('inspectionStepPageTitle.title.lineHeight')};
  padding-top: ${dt('inspectionStepPageTitle.paddingTop')};
  margin: 0 0 ${dt('inspectionStepPageTitle.marginBottom')} 0;
  box-sizing: border-box;
}`;
